<template>
  <div class="modal-overflow" style="max-height: 600px;">
    <div class="row">
      <div class="col-md-12">
        <el-input
          type="textarea"
          :rows="20"
          v-model="taskNameJson" />
      </div>
    </div>
    <div v-if="hasValidationErrors" style="margin-top: 12px;">
      <h6>Schema Validation Errors</h6>
      <ul>
        <li v-for="error in validationErrors">{{ maybeFilterProperty(error.property) }}: {{ error.message }}</li>
      </ul>
    </div>
    <div class="row" style="margin-top: 12px;">
      <div class="col-md-12">
        <button type="submit" @click.prevent="validateAndSubmit" class="btn btn-fill btn-info btn-wd pull-right">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import {notifyError, notifyWarning, notifySuccess} from 'src/utilities/utils'
import {validate} from 'jsonschema'
import {CREATED, OK} from 'http-status-codes'
import {ptracGet, ptracPost, ptracPut} from '@/utilities/ptracApi'

export default {
  computed: {
    hasValidationErrors() {
      return this.validationErrors.length > 0
    }
  },
  data() {
    return {
      taskNameJson: null,
      validationErrors: [],
      schema: {
        id: '/TaskName',
        type: 'object',
        properties: {
          name: {
            type: 'string'
          },
          key: {
            type: 'string'
          },
          taskTemplateId: {
            type: 'string'
          },
          departments: {
            type: 'array',
            items: {
              type: 'string'
            }
          },
          files: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                fileId: {
                  type: 'string'
                },
                name: {
                  type: 'string'
                },
                path: {
                  type: 'string'
                }
              }
            }
          },
          invoiceable: {
            type: 'boolean'
          },
          qbItemCodeId: {
            type: 'string'
          },
          active: {
            type: 'boolean'
          }
        },
        required: [
          'name',
          'key'
        ]
      }
    }
  },
  methods: {
    maybeFilterProperty(propertyName) {
      if (propertyName.indexOf('instance.') === 0) {
        return propertyName.substr(9)
      }
    },
    async validateAndSubmit() {
      this.validationErrors = []

      try {
        // if the JSON cannot be parsed, it will throw an error
        const taskName = JSON.parse(this.taskNameJson)
        taskName.ownerId = this.$store.get('security/userId')

        const validationResult = validate(taskName, this.schema)

        if (!validationResult.valid) {
          this.validationErrors = validationResult.errors
          notifyWarning(this, 'Your JSON is syntactically valid but it does not match the Task Name schema')
          return
        }

        const endpoint = 'task-names/'

        if (taskName.id) {
          const existsResponse = await ptracGet(endpoint + taskName.id)

          if (OK === existsResponse.status) {
            notifyWarning(this, taskName.name + ' exists. Import cancelled.')
            return
          }
        }

        let response = null

        if (taskName.id) {
          response = await ptracPut(endpoint+ taskName.id, taskName)
        } else {
          response = await ptracPost(endpoint, taskName)
        }

        if (CREATED === response.status) {
          notifySuccess(this, taskName.name + ' created successfully')
          this.$emit('close')
          return
        }

        notifyError(this, 'Failed to save task name', response.errors)
      } catch (e) {
        notifyError(this, 'Your JSON is not valid: ' + JSON.stringify(e))
      }
    }
  }
}
</script>
